import {
  BlockListSection as BlockListSectionType,
  BlockListSectionItem,
} from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { Box, SectionHeading, Text } from '../common/ui';
import { blockListItemsFromSection } from '../common/utils';

const BlockListSection = ({ section }: { section: BlockListSectionType }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const items = blockListItemsFromSection(section);
  return (
    <Box
      variant="sectionContainer"
      as="section"
      sx={{
        pageBreakInside: 'avoid',
      }}
    >
      <SectionHeading>{section.title}</SectionHeading>
      <Box
        variant="blockListSectionItemContainer"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        }}
      >
        {items.map((item: BlockListSectionItem, index) => (
          <Box sx={{ mb: calcSize(1.5), pr: 16 }} key={index}>
            <Text variant="sectionItemSubHeading">{item.primary}</Text>
            <Text
              sx={{
                color: 'secondaryText',
                whiteSpace: 'pre-wrap',
              }}
            >
              {item.secondary}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BlockListSection;
